import { isCssSize } from 'x1-base/utils';
import type {
    ContentBlockRenderedHeight,
    ContentBlockRenderedPosition
} from '~/types';

const BLOCK_HEIGHTS: Record<ContentBlockRenderedHeight, string> = {
    auto: 'auto',
    small: '24em',
    medium: '32em',
    large: '40em'
};

// For a flex-column container: justify-* is the vertical axis, align-* the horizontal.
const BLOCK_TEXT_POSITION_CLASSES: Record<ContentBlockRenderedPosition, string> = {
    'top-left': 'justify-start align-start',
    'top-center': 'justify-start align-center',
    'top-right': 'justify-start align-end',
    'middle-left': 'justify-center align-start',
    'middle-center': 'justify-center align-center',
    'middle-right': 'justify-center align-end',
    'bottom-left': 'justify-end align-start',
    'bottom-center': 'justify-end align-center',
    'bottom-right': 'justify-end align-end'
};

export interface UseContentBlocksUtilsOptions {}
export function useContentBlocksUtils(options: Partial<UseContentBlocksUtilsOptions> = {}) {

    function getBlockHeightStyle(height: ContentBlockRenderedHeight | (string & {})): string {
        const preset = BLOCK_HEIGHTS[height as ContentBlockRenderedHeight];
        return preset ?? (isCssSize(height) ? height : BLOCK_HEIGHTS.auto);
    }

    function getBlockTextPositionClasses(position: ContentBlockRenderedPosition): string {
        return BLOCK_TEXT_POSITION_CLASSES[position] ?? BLOCK_TEXT_POSITION_CLASSES['middle-center'];
    }

    return {
        getBlockHeightStyle,
        getBlockTextPositionClasses
    };
}
